import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetch("https://lider.tutorandy.xyz/php/validate.php", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.valid && data.usuario) {
          setUsuario(data.usuario); // Guardamos { id, nombre, rol }
        } else {
          setUsuario(null);
        }
        setCargando(false);
      })
      .catch(() => {
        setUsuario(null);
        setCargando(false);
      });
  }, []);

  if (cargando) return <p>Verificando sesión...</p>;
  if (!usuario) return <Navigate to="/" />;

  // Si children es una función, le pasamos el usuario
  return typeof children === "function" ? children(usuario) : children;
}
